import { t } from 'i18next';
import z from 'zod';

// Start with lowercase letter or digit, followed by lowercase letters or digits, optionally separated by dashes
// Disallows leading/trailing/consecutive dashes
const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const slug = (options?: { maxLength?: number }) => {
  const base = z.string().trim().regex(slugRegex, t('errors:forms.slug')).nonempty();

  return options?.maxLength
    ? base.max(options.maxLength, t('errors:forms.string.max', { max: options.maxLength }))
    : base;
};

export const slugStartingWithLetter = (options?: { maxLength?: number }) =>
  slug(options).refine((s) => !/^\d/.test(s), {
    error: t('errors:forms.slugStartingWithLetter'),
  });
